import axios from 'axios';
import { ListResponse } from 'types/api';
import { Charter } from 'types/charter';

export default async function fetchCharters() {
  const { data } = await axios.get<ListResponse<Charter>>(`/charters`);

  return data;
}
